import { AIDocType } from '@roc/feature-documents';
import { AIDocReviewTable } from './DocsReviewTable';
import { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { DocReviewBaseStore } from '../store/docReviewBaseStore';
import { Box, Grid, Paper, Typography, makeStyles } from '@material-ui/core';
import { SendForRevisionTable } from './SendForReviewTable';
import { Tabs } from "@roc/ui";
import { insertIf } from '@roc/feature-utils';
import { EditableToogleButton } from 'libs/feature-appraisals/src/appraisals/appraisalReview/appraisalReviewForm';
import { Document } from '@roc/feature-types';
import { DocumentChecklist } from './DocumentChecklist';
import { TaskStatus } from '@roc/feature-general-tasks';

const useStyles = makeStyles(() => ({
  paper: { border: '1.5px solid #E0E0E0FF' },
  toggleContainer: { padding: '0 30px' }
}));

export const AIDocReview = observer(({ type, loanId, docReviewStore, loanTask }:
  { type: AIDocType, loanId: any, docReviewStore: DocReviewBaseStore, loanTask: Document }) => {
  const { globalStore } = docReviewStore;
  const [tab, setTab] = useState(0);
  const classes = useStyles();

  const tabs = [
    ...insertIf(!globalStore.userFeatures.isClosingAttorney, [{
      label: 'Review Data Points'
    }]),
    {
      label: 'Needs Revision'
    },
    ...insertIf(type === AIDocType.CLOSING_DOCS, [{
      label: 'Pending Documents'
    }])
  ];

  useEffect(() => {
    docReviewStore.getDocReviewData(loanId, type);
  }, []);

  const isPendingDocumentTab = (tab === 2 || (tab === 1 && globalStore.userFeatures.isClosingAttorney));

  const isRevisionTab = (tab === 1 || (tab === 0 && globalStore.userFeatures.isClosingAttorney)) && !isPendingDocumentTab;

  return (
    <>
      {loanTask.status === TaskStatus.BEING_REVIEWED && globalStore.userFeatures.isClosingAttorney ?
        <Grid container spacing={1}>
          <Typography variant='h5'>Documents are currently under review</Typography>
        </Grid> :
        <Paper className={classes.paper}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Tabs
                tabs={tabs}
                selectedTab={tab}
                onTabChange={(e, index) => setTab(index)}
                right={
                  <Box className={classes.toggleContainer}>
                    {!isRevisionTab && !isPendingDocumentTab &&
                      <EditableToogleButton
                        checked={docReviewStore.showAllOnRevision}
                        label="Show All"
                        onClick={() => { docReviewStore.toggleShowAllOnRevision() }}
                      />}
                  </Box>}
              />
            </Grid>
            {tab === 0 && !globalStore.userFeatures.isClosingAttorney && <Grid item xs={12}>
              <AIDocReviewTable docType={type} store={docReviewStore} loanId={loanId} />
            </Grid>}
            {isRevisionTab && <Grid item xs={12}>
              <SendForRevisionTable store={docReviewStore} />
            </Grid>}
            {isPendingDocumentTab && <Grid item xs={12}>
              <DocumentChecklist store={docReviewStore} loanId={loanId} docType={type}
                readOnly={globalStore.userFeatures.isClosingAttorney} />
            </Grid>}
          </Grid>
        </Paper>}
    </>);
});
